import {
    call, put, all, takeLatest, spawn, select,
} from 'redux-saga/effects';
import Api from '../services/ApiManager';
import {Options, execFillRequest } from './effects';
import { getEventsActionType, getMonitoringGraphActionType, getMonitoringPathActionType, MonitoringGraphActionTypes
} from '../../model/monitoringGraph/actions';
import { getEventsAction, getMonitoringGraphAction, getMonitoringPathAction } from '../actions/monitoringGraphActions';

function* getMonitoringGraph(action: MonitoringGraphActionTypes) {
    const botId = yield select(state => state.bot.selectedBot);
    if (botId !== undefined) {
        const options: Options = {
            payload: [botId, action.payload],
        };
        yield call(execFillRequest,
            Api.monitoringGraph.get,
            getMonitoringGraphAction.success,
            getMonitoringGraphAction.failure,
            options);
    }
}

function* getMonitoringPath(action: MonitoringGraphActionTypes) {
    const botId = yield select(state => state.bot.selectedBot);
    if (botId !== undefined) {
        const options: Options = {
            payload: [botId, action.payload],
        };
        yield call(execFillRequest,
            Api.monitoringGraph.getPath,
            getMonitoringPathAction.success,
            getMonitoringPathAction.failure,
            options);
    }
}

function* getFilters(){
    const botId = yield select(state => state.bot.selectedBot);
    if (botId !== undefined){
        const options: Options ={
            payload: [botId],
        };
        yield call(execFillRequest, 
            Api.monitoringGraph.getFilter, 
            getEventsAction.success,
            getEventsAction.failure,
            options);
    }
}

export function* startMonitoringGraphsSagas() {
    yield all([
        takeLatest(getMonitoringGraphActionType.request, getMonitoringGraph),
        takeLatest(getMonitoringPathActionType.request, getMonitoringPath),
        takeLatest(getEventsActionType.request, getFilters),
    ]);
}


